import axios from 'axios'

import { ChanneledRequestParams, Specialisation } from 'types'

export const getSpecialisations = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Specialisation[]>('/specialisations', {
      params,
    })
  ).data
}
